import {
  ADD_TOASTER,
  ADD_TOASTER_TIMEOUT,
  ADD_TOOLTIP,
  DEACTIVATE_TOASTER,
  REMOVE_TOASTER,
  ToasterAction,
  ToasterState
} from './types';

const initialState: ToasterState = {
  toasters: [],
  currentId: 0,
};

export default function (state = initialState, action: ToasterAction): ToasterState {
  switch (action.type) {
    case ADD_TOASTER:
      let addToasters = [...state.toasters]
      if (state.toasters) {
        addToasters.push({ toaster: action.payload.toaster, isActive: true, hasTimeout: false, id: state.currentId });
      }

      return {
        ...state,
        toasters: addToasters,
        currentId: state.currentId + 1
      };

    case ADD_TOASTER_TIMEOUT:
      return {
        ...state,
        toasters: state.toasters
      };

    case ADD_TOOLTIP: {
      return {
        ...state,
        tooltip: {
          message: action.payload.toaster.message,
          title: action.payload.toaster.title,
          type: action.payload.toaster.type
        }
      };
    }
    case DEACTIVATE_TOASTER:
      if (state.toasters.length) {

        const toastersList = [...state.toasters]
        const indexToUpdate = toastersList.findIndex(toaster => toaster.id === action.payload.id)
        toastersList[indexToUpdate].isActive = false

        return {
          ...state,
          toasters: toastersList
        }
      }

      return { ...state }

    case REMOVE_TOASTER:
      if (state.toasters.length) {
        return {
          ...state,
          toasters: state.toasters.filter(obj => obj.id !== action.payload.id)
        }
      }

      return { ...state }
    default:
      return state;
  }
}
